import React from 'react';
import propTypes from 'prop-types';



PlaceholderImage.propTypes = {
  loadImage: propTypes.string,
};


export default function PlaceholderImage(props) {
  let { loadImage } = props;
  loadImage = require(`../../images/${loadImage ? loadImage : 'poisLoadImage.svg'}`);
  return (
    <div className="empty-placeholder">
      <img src={loadImage} alt="占位符"/>
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/components/PlaceholderImage/index.js